import React from 'react';

import Categories from '../../components/categories/Categories';
import PageTitle from '../../components/page-title/PageTitle';
import PodcastRow from '../../components/podcast-row/PodcastRow';

const HomePage = () => {
  return (
    <div>
      <PageTitle>Popular</PageTitle>
      <PodcastRow categoryId="67" />
      <Categories />
    </div>
  );
};

export default HomePage;
